module.exports = __webpack_public_path__ + "static/media/file-powerpoint.07e199fe.svg";